<template>
  <router-view />
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "home",
  data() {
    return {};
  },
  computed: mapState({
    userIdentity: (state) => state.app.userIdentity,
    salesAuthority: (state) => state.app.salesAuthority,
  }),
  created() {
    this.$store.commit("app/setShowTitle", false);
  },
};
</script>
